var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 1.75H11.6667C11.9888 1.75 12.25 2.01117 12.25 2.33333V6.41667H11.0833V2.91667H2.91667V4.66667L0 2.33333L2.91667 0V1.75ZM9.91667 11.0833H1.16667C0.844503 11.0833 0.583333 10.8222 0.583333 10.5V6.41667H1.75V9.91667H9.91667V8.16667L12.8333 10.5L9.91667 12.8333V11.0833Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatIcon);
export default __webpack_public_path__ + "static/media/RepeatIcon.df0444283a9de157e1decc0f4fa18055.svg";
export { ForwardRef as ReactComponent };